import React from 'react';
import { Search, Wrench, TrendingUp } from 'lucide-react';

export function HowItWorks() {
  return (
    <div className="py-10 bg-black/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            How working together works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Step 1 */}
          <div className="bg-black/40 border border-blue-500/20 rounded-lg p-8 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500/10 rounded-full mb-6">
              <Search className="w-8 h-8 text-blue-500" />
            </div>
            <div className="text-4xl font-bold text-blue-500 mb-2">1</div>
            <h3 className="text-xl font-bold text-white mb-4">Quick audit</h3>
            <p className="text-gray-300 leading-relaxed">
              You fill out the Start Here form and we review your current marketing, website, and call handling. You get a short Loom video walking through where you're leaving money on the table.
            </p>
          </div>

          {/* Step 2 */}
          <div className="bg-black/40 border border-blue-500/20 rounded-lg p-8 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500/10 rounded-full mb-6">
              <Wrench className="w-8 h-8 text-blue-500" />
            </div>
            <div className="text-4xl font-bold text-blue-500 mb-2">2</div>
            <h3 className="text-xl font-bold text-white mb-4">Plan & build your system</h3>
            <p className="text-gray-300 leading-relaxed">
              We decide if you need more clients (marketing focus) or better capture of existing demand (lead rescue & automation). Then we build the system around your current tools instead of forcing you onto new software.
            </p>
          </div>

          {/* Step 3 */}
          <div className="bg-black/40 border border-blue-500/20 rounded-lg p-8 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500/10 rounded-full mb-6">
              <TrendingUp className="w-8 h-8 text-blue-500" />
            </div>
            <div className="text-4xl font-bold text-blue-500 mb-2">3</div>
            <h3 className="text-xl font-bold text-white mb-4">Go live and refine</h3>
            <p className="text-gray-300 leading-relaxed">
              We test everything, go live, and then refine based on real-world results—so your calendar and cash flow improve over time, not just on day one.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
